import { AddItemByInputAction, OrderingInitialState } from '@reducers/ordering/types';

export const addItemByInput = (state: OrderingInitialState, action: AddItemByInputAction): OrderingInitialState => {
  const { tempId, value } = action.payload;
  const menuItemsCount = state.orderState.menus?.map((item) => item.count || 0).reduce((a, b) => a + b, 1);

  if (Number(value) === 0) {
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: state.orderState.menus.filter((x) => x.tempId !== tempId),
        menuItemsCount,
      },
    };
  }
  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: state.orderState.menus.map((item) => {
        if (item.tempId === tempId) {
          return {
            ...item,
            count: parseInt(value, 10),
            orderItemToppings: item?.orderItemToppings?.map((x) => ({
              ...x,
              count: parseInt(value, 10),
            })),
          };
        }
        return item;
      }),
      menuItemsCount,
    },
  };
};
